import { trpc } from "@/utils/trpc";
import {
	createFileRoute,
	Outlet,
	redirect,
	useParams,
	useRouteContext,
} from "@tanstack/react-router";

export const Route = createFileRoute("/$workspaceId/projects")({
	beforeLoad: async ({ context, location, params }) => {
		// const { queryClient } = context;
		// const { workspaceId } = params;
		// const channels = await queryClient.ensureQueryData(
		//   trpc.channel.getByWorkspace.queryOptions({ workspaceId: Number(workspaceId) })
		// );
		// const isMember = channels.find((channel) => channel.id == Number(channelId));
		// if (!isMember) {
		//   const generalChannel = channels.find((channel) => channel.title?.toLowerCase().includes("general"));
		//   throw redirect({
		//     to: "/$workspaceId/projects/$channelId",
		//     params: {
		//       workspaceId,
		//       channelId: generalChannel?.id,
		//     },
		//   });
		// }
		// return { channels };
	},
});
